/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
/* eslint-disable react-native/no-color-literals */
/*
Author: Gilang Romadhanu Tartila
*/
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { isWeb, fullWidth, fullHeight } from '@global/screens';
import { ARROW_SIZE } from '@/constants';
import Colors from '@global/colors';
import {
  currency,
  parseDate,
  downloadFile,
  getFileNameFromUrl,
} from '@global/helpers';
import ModalFull from '@components/modal/ModalFull';
import ModalImage from '@components/modal/ModalImage';
import Table from '@components/table/Table';
import Image from '@components/global/Image';
import StatusBadge from '@components/global/StatusBadge';
import SociollaText from '@components/sociolla/SociollaText';

const widthContainer = isWeb ? '100%' : fullWidth - 30;
// import { MsB2b } from '@api/ms-b2b';
import VisibilityUpdateProductCard from '@/screens/sales-activity/components/todo-list/visibility-update/VisibilityUpdateProductCard';
import CustomerDisplay from '@/screens/sales-activity/components/todo-list/customer-display/CustomerDisplay';
import CompetitorUpdateSection from '@/screens/sales-activity/components/todo-list/competitor-update/CompetitorUpdate';
import VisitReport from '@/screens/sales-activity/components/todo-list/visit-report/VisitReport';
import GwpTrackerDisplay from '@/screens/sales-activity/components/todo-list/gwp-tracker/GwpTrackerDisplay';
import SellOutReportDisplay from '@/screens/sales-activity/components/todo-list/sell-out-report/SellOutReportDisplay';
import { limit } from './on-going/todo-visibility-update/TodoVisibilityUpdate.utils';

const tableStructure = {
  reference_code: {
    head: 'Order Number',
    body: 'reference_code',
    type: 'slot',
  },
  order_date: {
    head: 'Order Date',
    body: 'order_date',
    type: 'date',
  },
  total_amount: {
    head: 'Total Value',
    body: 'total_amount',
    type: 'currency',
  },
  status: {
    head: 'Status',
    body: 'status',
    type: 'status',
  },
  invoice_status: {
    head: 'Invoice Status',
    body: 'invoice_status',
    type: 'status',
  },
};

const TodoListVisit = ({
  route = null,
  navigation = null,
  detailData = {},
  detailTodos = [],
  onCloseDetail = () => {},
}) => {
  // const defaultTab = [
  //   'customer_display',
  //   'competitor_update',
  //   'visibility_update',
  //   'orders',
  //   'invoice_collection',
  //   'npd_presentation',
  //   'gwp_tracker',
  //   'sell_out_report',
  // ];

  const userRole = useSelector((state) => state.auth.user)?.role?.code;
  const [activeTab, setActiveTab] = useState([]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (
        detailData?._id &&
        route?.params?.direct &&
        activeTab != route?.params?.direct
      ) {
        setActiveTab(route.params.direct);
      }
    }
    return () => {
      mounted = false;
    };
  }, [detailData]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (route?.params?.direct && activeTab == route.params.direct) {
        setTimeout(() => {
          navigation.setParams({ direct: '' });
        }, 500);
      }
    }
    return () => {
      mounted = false;
    };
  }, [activeTab]);

  const tabs = [
    { label: 'CUSTOMER DISPLAY', value: 'customer_display' },
    { label: 'COMPETITOR UPDATE', value: 'competitor_update' },
    { label: 'VISIBILITY UPDATE', value: 'visibility_update' },
    { label: 'VISIT REPORT', value: 'npd_presentation' },
    { label: 'ORDER', value: 'orders' },
    { label: 'COLLECT INVOICE / PAYMENT', value: 'invoice_collection' },
    { label: 'GWP TRACKER', value: 'gwp_tracker' },
    { label: 'SELL-OUT VALIDATION REPORT', value: 'sell_out_report' },
  ];
  if (
    userRole == 'beauty_advisor' ||
    detailData?.user?.role == 'beauty_advisor'
  ) {
    tabs.splice(4, 2);
  } else if (
    userRole == 'merchandiser' ||
    detailData?.user?.role == 'merchandiser'
  ) {
    tabs.splice(4, 4);
  } else {
    tabs.splice(6, 2);
  }

  const isActive = (value) => activeTab.indexOf(value) > -1;

  const TabExpand = ({ title, value }) => {
    const changeTab = () => {
      if (isWeb) {
        const temp = JSON.parse(JSON.stringify(activeTab));
        const index = temp.indexOf(value);
        if (index > -1) {
          temp.splice(index, 1);
        } else {
          temp.push(value);
        }
        setActiveTab(temp);
      } else {
        setActiveTab([value]);
      }
    };
    return (
      <TouchableOpacity
        testID={`todo-visit-tab-expand-${value}`}
        onPress={() => changeTab()}
        activeOpacity={0.6}
        style={{
          width: '100%',
          backgroundColor: Colors.grey3,
          paddingHorizontal: 15,
          paddingVertical: 17,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          ...(!isWeb
            ? {
                backgroundColor: Colors.white,
                borderBottomColor: Colors.grey0,
                borderBottomWidth: 1,
              }
            : {}),
        }}>
        <SociollaText
          type="medium"
          style={{ color: Colors.grey1, textTransform: 'uppercase' }}>
          {title}
        </SociollaText>
        <Image
          style={[
            ARROW_SIZE,
            {
              marginRight: isWeb ? 5 : -10,
              transform: [
                {
                  rotate: !isWeb
                    ? '-90deg'
                    : isActive(value)
                    ? '180deg'
                    : '0deg',
                },
              ],
            },
          ]}
          width={ARROW_SIZE.width}
          height={ARROW_SIZE.height}
          svg={true}
          source={require('@assets/img/icons/arrow-down-grey.svg')}
        />
      </TouchableOpacity>
    );
  };
  const dataCustomerDisplay = detailTodos.find(
    (a) => a.target_type == 'customer_display',
  );
  let beforeImage = [];
  let afterImage = [];
  if (dataCustomerDisplay) {
    const detailCustomerDisplay = dataCustomerDisplay.more_info || {};
    const before = detailCustomerDisplay.attachments?.length
      ? detailCustomerDisplay.attachments.find(
          (a) => a.type == 'customer_before_visit',
        )
      : [];
    beforeImage = before?.image?.length
      ? before.image.map((a) => ({ url: a.url, text: a.text || '' }))
      : [];
    const after = detailCustomerDisplay.attachments?.length
      ? detailCustomerDisplay.attachments.find(
          (a) => a.type == 'customer_after_visit',
        )
      : [];
    afterImage = after?.image?.length
      ? after.image.map((a) => {
          return {
            url: a.url,
            text: a.text || '',
          };
        })
      : [];
  }
  const dataCustomerDisplayExtras =
    dataCustomerDisplay?.more_info?.attachments || [];
  const endGondolaImage = (
    dataCustomerDisplayExtras.find((a) => a.type == 'customer_end_gondola')
      ?.image || []
  ).map((a) => ({ url: a.url, text: a.text || '' }));
  const standeeImage = (
    dataCustomerDisplayExtras.find((a) => a.type == 'customer_standee')
      ?.image || []
  ).map((a) => ({ url: a.url, text: a.text || '' }));
  const cocImage = (
    dataCustomerDisplayExtras.find((a) => a.type == 'customer_coc')?.image || []
  ).map((a) => ({ url: a.url, text: a.text || '' }));
  const dataNpsPresentation = detailTodos.find(
    (a) => a.target_type == 'npd_presentation',
  );
  let notes = [];
  let plan_npd = [];
  if (dataNpsPresentation) {
    const detailNotes = dataNpsPresentation.more_info || {};
    notes = detailNotes.notes?.length
      ? detailNotes.notes.filter((a) => a.type == 'npd_presentation')
      : [];

    const detailPlan = dataNpsPresentation.more_info || {};
    plan_npd = detailPlan.plan_for_next_visit?.length
      ? detailPlan.plan_for_next_visit.filter(
          (a) => a.type == 'npd_presentation',
        )
      : [];
  }
  const dataInvoiceCollection = detailTodos.find(
    (a) => a.target_type == 'invoice_collection',
  );
  let invoices = [];
  if (dataInvoiceCollection) {
    const detailInvoice = dataInvoiceCollection.more_info || {};
    invoices = detailInvoice.notes?.length
      ? detailInvoice.notes.filter((a) => a.type == 'invoice')
      : [];
  }
  const dataVisibilityUpdate = detailTodos.find(
    (a) => a.target_type == 'visibility_update',
  );
  let products = [];
  if (dataVisibilityUpdate) {
    const detailProduct = dataVisibilityUpdate || {};
    products = detailProduct.products?.length ? detailProduct.products : [];
  }
  let otherProducts = [];
  if (dataVisibilityUpdate) {
    const detailProduct = dataVisibilityUpdate || {};
    otherProducts = detailProduct.other_products?.length
      ? detailProduct.other_products
      : [];
  }
  const dataCompetitorUpdate = detailTodos.find(
    (a) => a.target_type == 'competitor_update',
  );
  let competitorImage = [];
  if (dataCompetitorUpdate) {
    const detailCompetitorUpdate = dataCompetitorUpdate.more_info || {};
    const competitor = detailCompetitorUpdate.attachments?.length
      ? detailCompetitorUpdate.attachments.find((a) => a.type == 'competitor')
      : [];
    competitorImage = competitor?.image?.length
      ? competitor.image.map((a) => {
          return {
            url: a.url,
            text: a.text || '',
          };
        })
      : [];
  }
  const dataOrder = detailTodos.find((a) => a.target_type == 'orders');
  let orders = [];
  if (dataOrder) {
    const detailProduct = dataOrder || {};
    orders = detailProduct.orders?.length ? detailProduct.orders : [];
  }

  const dataGwpTracker = detailTodos.find(
    (a) => a.target_type == 'gwp_tracker',
  );
  const gwpTrackers = dataGwpTracker?.more_info?.campaign?.length
    ? dataGwpTracker.more_info.campaign
    : [];
  const dataSellOutReport = detailTodos.find(
    (a) => a.target_type == 'sell_out_report',
  );
  const reports = dataSellOutReport?.more_info?.report?.length
    ? dataSellOutReport.more_info.report
    : [];

  const Invoice = () => {
    return (
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{ flex: 1, width: '100%', padding: 15 }}>
        {invoices?.length ? (
          <View
            style={{
              maxWidth: widthContainer,
              flexDirection: isWeb ? 'row' : 'column',
              flexWrap: isWeb ? 'wrap' : 'nowrap',
              gap: isWeb ? 12 : 0,
              marginBottom: 40,
            }}>
            {invoices.map((item, idx) => (
              <View
                style={[
                  styles.invoiceCard,
                  isWeb && { width: 'calc(50% - 6px)' },
                ]}
                key={idx}>
                {/* Blue accent bar */}
                <View style={styles.invoiceCardAccent} />

                {/* Header */}
                <View style={styles.invoiceCardHeader}>
                  <SociollaText type="semibold" style={styles.invoiceCardTitle}>
                    Note #{idx + 1}
                  </SociollaText>
                </View>

                <View style={styles.invoiceCardDivider} />

                {/* Invoice number chips */}
                <View style={styles.invoiceCardSection}>
                  <SociollaText style={styles.invoiceSectionLabel}>
                    Invoice
                  </SociollaText>
                  <View style={styles.invoiceChipsRow}>
                    {item.invoice_number?.length ? (
                      item.invoice_number.map((num, i) => (
                        <View key={i} style={styles.invoiceChip}>
                          <SociollaText style={styles.invoiceChipText}>
                            {num}
                          </SociollaText>
                        </View>
                      ))
                    ) : (
                      <SociollaText
                        style={{ fontSize: 12, color: Colors.grey1 }}>
                        -
                      </SociollaText>
                    )}
                  </View>
                </View>

                <View style={styles.invoiceCardDivider} />

                {/* Amount & Status */}
                <View style={styles.invoiceCardSection}>
                  <SociollaText style={styles.invoiceSectionLabel}>
                    Amount
                  </SociollaText>
                  <SociollaText type="medium">
                    {item.amount_invoice || item.amount_invoice === 0
                      ? currency(item.amount_invoice, true)
                      : '-'}
                  </SociollaText>
                </View>
                <View style={styles.invoiceCardSection}>
                  <SociollaText style={styles.invoiceSectionLabel}>
                    Status
                  </SociollaText>
                  <View style={{ alignSelf: 'flex-start' }}>
                    {item.status_invoice ? (
                      <StatusBadge status={item.status_invoice} />
                    ) : (
                      <SociollaText>-</SociollaText>
                    )}
                  </View>
                </View>

                <View style={styles.invoiceCardDivider} />

                {/* Notes */}
                <View style={styles.invoiceCardSection}>
                  <SociollaText style={styles.invoiceSectionLabel}>
                    Notes
                  </SociollaText>
                  <View style={styles.invoiceNotesBubble}>
                    <SociollaText style={styles.invoiceNoteText}>
                      {item.text || '-'}
                    </SociollaText>
                  </View>
                </View>

                {/* Attachment */}
                {!!item.invoice_attachment_url && (
                  <>
                    <View style={styles.invoiceCardDivider} />
                    <View style={styles.invoiceCardSection}>
                      <SociollaText style={styles.invoiceSectionLabel}>
                        Attachment
                      </SociollaText>
                      <TouchableOpacity
                        testID={`todo-visit-invoice-attachment-btn-${idx}`}
                        activeOpacity={0.7}
                        style={styles.invoiceAttachmentRow}
                        onPress={() =>
                          downloadFile(
                            item.invoice_attachment_url,
                            'invoice-attachment',
                            '',
                            true,
                          )
                        }>
                        <Image
                          style={{ width: 16, height: 16, marginRight: 6 }}
                          width={16}
                          height={16}
                          isResolveAsset
                          source={require('@/assets/img/icons/attachment.png')}
                        />
                        <SociollaText style={styles.invoiceAttachmentText}>
                          {getFileNameFromUrl(
                            item.invoice_attachment_url,
                            'Invoice',
                          )}
                        </SociollaText>
                      </TouchableOpacity>
                    </View>
                  </>
                )}
              </View>
            ))}
          </View>
        ) : (
          <View style={styles.invoiceEmptyState}>
            <SociollaText style={styles.invoiceEmptyText}>
              No invoice collection notes found
            </SociollaText>
          </View>
        )}
      </ScrollView>
    );
  };

  const VisibilityUpdate = () => {
    const pageSize = limit;
    const [activeVisibilityTab, setActiveVisibilityTab] = useState('product');
    const [visibleCount, setVisibleCount] = useState(pageSize);

    useEffect(() => {
      setVisibleCount(pageSize);
    }, [activeVisibilityTab, dataVisibilityUpdate?._id]);

    const tabOptions = [
      { key: 'product', label: 'Product', count: products?.length || 0 },
      {
        key: 'other_product',
        label: 'Other Product',
        count: otherProducts?.length || 0,
      },
    ];

    const isOtherTab = activeVisibilityTab === 'other_product';
    const currentList = isOtherTab ? otherProducts : products;
    const visibleList = currentList.slice(0, visibleCount);
    const hasMore = currentList.length > visibleList.length;

    return (
      <ScrollView showsVerticalScrollIndicator={false} style={styles.vuScroll}>
        <View style={styles.vuContentContainer}>
          <View style={styles.vuTabsContainer}>
            {tabOptions.map((tab) => {
              const isActiveTab = activeVisibilityTab === tab.key;
              return (
                <TouchableOpacity
                  testID={`todo-visit-vu-tab-${tab.key}`}
                  key={tab.key}
                  activeOpacity={0.8}
                  style={[
                    styles.vuTabButton,
                    isActiveTab && styles.vuTabButtonActive,
                  ]}
                  onPress={() => setActiveVisibilityTab(tab.key)}>
                  <SociollaText
                    type={isActiveTab ? 'medium' : 'regular'}
                    style={[
                      styles.vuTabText,
                      isActiveTab && styles.vuTabTextActive,
                    ]}>
                    {tab.label}
                  </SociollaText>
                  <View
                    style={[
                      styles.vuTabBadge,
                      isActiveTab && styles.vuTabBadgeActive,
                    ]}>
                    <SociollaText
                      type="medium"
                      style={[
                        styles.vuTabBadgeText,
                        isActiveTab && styles.vuTabBadgeTextActive,
                      ]}>
                      {tab.count}
                    </SociollaText>
                  </View>
                </TouchableOpacity>
              );
            })}
          </View>

          {visibleList?.length ? (
            visibleList.map((item, idx) => (
              <VisibilityUpdateProductCard
                item={item}
                key={`${activeVisibilityTab}-${idx}`}
                userRole={detailData?.user?.role}
              />
            ))
          ) : (
            <View style={styles.vuEmptyState}>
              <Image
                style={{ width: 60, height: 60, marginTop: 20 }}
                width={60}
                height={60}
                source={require('@assets/img/icons/no-product.svg')}
                svg={true}
              />
              <SociollaText style={styles.vuEmptyText}>
                No product found
              </SociollaText>
            </View>
          )}

          {hasMore ? (
            <TouchableOpacity
              testID="todo-visit-vu-load-more-btn"
              style={styles.vuLoadMoreButton}
              activeOpacity={0.6}
              onPress={() => {
                setVisibleCount((prev) => prev + pageSize);
              }}>
              <SociollaText style={styles.vuLoadMoreText}>
                Load More
              </SociollaText>
            </TouchableOpacity>
          ) : (
            false
          )}
        </View>
      </ScrollView>
    );
  };

  const goToOrderDetail = (item) => {
    if (navigation) {
      onCloseDetail();
      setTimeout(() => {
        navigation.navigate('SalesOrderNavigator', {
          screen: 'SalesOrderDetailScreen',
          params: {
            activityId: detailData?._id,
            taskId: dataOrder?._id,
            id: item._id,
            name: item.reference_code,
            titleScreen: item.reference_code,
          },
        });
      }, 500);
    }
  };

  const OrderList = useMemo(() => {
    return isWeb ? (
      <Table
        name="sales-activity-order"
        structures={tableStructure}
        loading={false}
        data={orders}
        searchKey="reference_code"
        searchPlaceholder="Search by order number"
        hasNoHide
        showSearch={false}
        showPagination={false}
        showFilter={false}
        slot={{
          reference_code: ({ data, index }) => (
            <TouchableOpacity
              activeOpacity={0.8}
              key={index}
              onPress={() => goToOrderDetail(data)}>
              <SociollaText
                type="medium"
                style={{
                  fontSize: 13,
                  color: Colors.blue0,
                  ...(data?.reference_code
                    ? { textDecorationLine: 'underline' }
                    : {}),
                }}
                key={`reference-${index}`}>
                {data?.reference_code ? data.reference_code : '-'}
              </SociollaText>
            </TouchableOpacity>
          ),
        }}
      />
    ) : (
      <>
        {orders.map((item, idx) => (
          <TouchableOpacity
            testID={`todo-visit-order-item-${idx}`}
            key={idx}
            activeOpacity={0.8}
            style={styles.orderCard}
            onPress={() => goToOrderDetail(item)}>
            {/* Top accent bar */}
            <View style={styles.orderCardAccent} />

            {/* Header: order number + status */}
            <View style={styles.orderCardHeader}>
              <SociollaText type="semibold" style={styles.orderCardNumber}>
                {item.reference_code || '-'}
              </SociollaText>
              <StatusBadge status={item.status} />
            </View>

            <View style={styles.orderCardDivider} />

            {/* Footer: date + amount */}
            <View style={styles.orderCardFooter}>
              <SociollaText style={styles.orderCardDate}>
                {item.order_date ? parseDate(item.order_date) : '-'}
              </SociollaText>
              <SociollaText type="semibold" style={styles.orderCardAmount}>
                {currency(item.total_amount, true)}
              </SociollaText>
            </View>
          </TouchableOpacity>
        ))}
      </>
    );
  }, [orders]);

  const Order = () => {
    return (
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{ flex: 1, width: '100%' }}
        contentContainerStyle={{ padding: 15 }}>
        {orders?.length ? (
          <View style={{ maxWidth: widthContainer, marginBottom: 40 }}>
            {OrderList}
          </View>
        ) : (
          <View style={styles.orderEmptyState}>
            <SociollaText style={styles.orderEmptyText}>
              No orders found
            </SociollaText>
          </View>
        )}
      </ScrollView>
    );
  };

  return (
    <View testID="todo-visit-container" style={{ width: '100%' }}>
      {tabs.map((item, idx) => (
        <View style={{ width: '100%' }} key={idx}>
          <TabExpand title={item.label} value={item.value} />
          {isActive(item.value) ? (
            <View style={{ width: '100%' }}>
              {item.value == 'customer_display' ? (
                <>
                  {isWeb ? (
                    <>
                      <CustomerDisplay
                        beforeImage={beforeImage}
                        afterImage={afterImage}
                        endGondolaImage={endGondolaImage}
                        standeeImage={standeeImage}
                        cocImage={cocImage}
                        userRole={detailData?.user?.role || userRole}
                      />
                    </>
                  ) : (
                    <ModalFull
                      testID={`todo-visit-modal-${item.value}`}
                      title={item.label}
                      show={activeTab.indexOf(item.value) > -1}
                      back={isWeb ? false : true}
                      width={650}
                      onClose={() => setActiveTab([])}>
                      <CustomerDisplay
                        beforeImage={beforeImage}
                        afterImage={afterImage}
                        endGondolaImage={endGondolaImage}
                        standeeImage={standeeImage}
                        cocImage={cocImage}
                        userRole={detailData?.user?.role || userRole}
                      />
                      <ModalImage />
                    </ModalFull>
                  )}
                </>
              ) : item.value == 'competitor_update' ? (
                <>
                  {isWeb ? (
                    <>
                      <CompetitorUpdateSection images={competitorImage} />
                    </>
                  ) : (
                    <ModalFull
                      testID={`todo-visit-modal-${item.value}`}
                      title={item.label}
                      show={activeTab.indexOf(item.value) > -1}
                      back={isWeb ? false : true}
                      width={650}
                      onClose={() => setActiveTab([])}>
                      <CompetitorUpdateSection images={competitorImage} />
                      <ModalImage />
                    </ModalFull>
                  )}
                </>
              ) : item.value == 'visibility_update' ? (
                <>
                  {isWeb ? (
                    <>
                      <VisibilityUpdate />
                    </>
                  ) : (
                    <ModalFull
                      testID={`todo-visit-modal-${item.value}`}
                      title={item.label}
                      show={activeTab.indexOf(item.value) > -1}
                      back={isWeb ? false : true}
                      width={650}
                      onClose={() => setActiveTab([])}>
                      <VisibilityUpdate />
                    </ModalFull>
                  )}
                </>
              ) : item.value == 'orders' ? (
                <>
                  {isWeb ? (
                    <>
                      <Order />
                    </>
                  ) : (
                    <ModalFull
                      testID={`todo-visit-modal-${item.value}`}
                      title={item.label}
                      show={activeTab.indexOf(item.value) > -1}
                      back={isWeb ? false : true}
                      width={650}
                      onClose={() => setActiveTab([])}>
                      <Order />
                    </ModalFull>
                  )}
                </>
              ) : item.value == 'invoice_collection' ? (
                <>
                  {isWeb ? (
                    <>
                      <Invoice />
                    </>
                  ) : (
                    <ModalFull
                      testID={`todo-visit-modal-${item.value}`}
                      title={item.label}
                      show={activeTab.indexOf(item.value) > -1}
                      back={isWeb ? false : true}
                      width={650}
                      onClose={() => setActiveTab([])}>
                      <Invoice />
                    </ModalFull>
                  )}
                </>
              ) : item.value == 'npd_presentation' ? (
                <>
                  {isWeb ? (
                    <>
                      <VisitReport notes={notes} plan_npd={plan_npd} />
                    </>
                  ) : (
                    <ModalFull
                      testID={`todo-visit-modal-${item.value}`}
                      title={item.label}
                      show={activeTab.indexOf(item.value) > -1}
                      back={isWeb ? false : true}
                      width={650}
                      onClose={() => setActiveTab([])}>
                      <VisitReport notes={notes} plan_npd={plan_npd} />
                    </ModalFull>
                  )}
                </>
              ) : item.value == 'gwp_tracker' ? (
                <>
                  {isWeb ? (
                    <>
                      <GwpTrackerDisplay gwpTrackers={gwpTrackers} />
                    </>
                  ) : (
                    <ModalFull
                      testID={`todo-visit-modal-${item.value}`}
                      title={item.label}
                      show={activeTab.indexOf(item.value) > -1}
                      back={isWeb ? false : true}
                      width={650}
                      onClose={() => setActiveTab([])}>
                      <GwpTrackerDisplay gwpTrackers={gwpTrackers} />
                      <ModalImage />
                    </ModalFull>
                  )}
                </>
              ) : item.value == 'sell_out_report' ? (
                <>
                  {isWeb ? (
                    <>
                      <SellOutReportDisplay reports={reports} />
                    </>
                  ) : (
                    <ModalFull
                      testID={`todo-visit-modal-${item.value}`}
                      title={item.label}
                      show={activeTab.indexOf(item.value) > -1}
                      back={isWeb ? false : true}
                      width={650}
                      onClose={() => setActiveTab([])}>
                      <SellOutReportDisplay reports={reports} />
                    </ModalFull>
                  )}
                </>
              ) : (
                false
              )}
            </View>
          ) : (
            false
          )}
        </View>
      ))}
      {isWeb ? <ModalImage /> : false}
    </View>
  );
};

const styles = StyleSheet.create({
  vuScroll: {
    flex: 1,
    width: '100%',
    backgroundColor: Colors.grey3,
    paddingTop: 8,
  },
  vuContentContainer: {
    width: '100%',
    maxWidth: isWeb ? 980 : '100%',
    alignSelf: 'center',
    paddingHorizontal: isWeb ? 14 : 0,
    paddingBottom: isWeb ? 12 : 0,
  },
  vuTabsContainer: {
    marginHorizontal: isWeb ? 0 : 12,
    marginBottom: 8,
    padding: 4,
    borderRadius: 10,
    backgroundColor: Colors.white,
    flexDirection: 'row',
    borderColor: Colors.grey0,
    borderWidth: 1,
  },
  vuTabButton: {
    flex: 1,
    borderRadius: 8,
    paddingVertical: isWeb ? 8 : 10,
    paddingHorizontal: 8,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  vuTabButtonActive: {
    backgroundColor: Colors.blue9,
  },
  vuTabText: {
    fontSize: isWeb ? 14 : 12,
    color: Colors.grey2,
  },
  vuTabTextActive: {
    color: Colors.blue0,
  },
  vuTabBadge: {
    borderRadius: 11,
    marginLeft: 6,
    paddingVertical: 2,
    paddingHorizontal: 12,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.grey3,
  },
  vuTabBadgeActive: {
    backgroundColor: Colors.blue0,
  },
  vuTabBadgeText: {
    fontSize: 12,
  },
  vuTabBadgeTextActive: {
    color: Colors.white,
  },
  vuLoadMoreButton: {
    width: '100%',
    paddingVertical: 14,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.white,
    borderTopColor: Colors.grey0,
    borderTopWidth: 1,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
    borderRadius: isWeb ? 10 : 0,
    marginTop: isWeb ? 2 : 0,
  },
  vuLoadMoreText: {
    color: Colors.blue0,
    fontSize: 12,
  },
  vuEmptyState: {
    padding: 18,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20,
    backgroundColor: Colors.white,
    borderRadius: isWeb ? 10 : 0,
    borderColor: Colors.grey0,
    borderWidth: isWeb ? 1 : 0,
    ...(isWeb ? {} : { flex: 1, height: fullHeight - 150 }),
  },
  vuEmptyText: {
    color: Colors.grey13,
    textAlign: 'center',
    fontSize: 12,
  },
  // Invoice collection display
  invoiceCard: {
    width: '100%',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    overflow: 'hidden',
    marginBottom: 14,
  },
  invoiceCardAccent: {
    height: 4,
    backgroundColor: Colors.blue0,
    width: '100%',
  },
  invoiceCardHeader: {
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  invoiceCardTitle: {
    fontSize: 13,
    color: Colors.blue1,
  },
  invoiceCardDivider: {
    height: 1,
    backgroundColor: Colors.grey0,
  },
  invoiceCardSection: {
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  invoiceSectionLabel: {
    fontSize: 11,
    color: Colors.grey1,
    marginBottom: 6,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  invoiceChipsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  invoiceChip: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 6,
    backgroundColor: '#eef1fb',
    borderWidth: 1,
    borderColor: '#c7d0f5',
    marginBottom: 4,
    marginRight: 6,
  },
  invoiceChipText: {
    fontSize: 12,
    color: Colors.blue0,
  },
  invoiceNotesBubble: {
    backgroundColor: Colors.grey17,
    borderRadius: 6,
    padding: 10,
  },
  invoiceNoteText: {
    fontSize: 12,
    color: Colors.grey14,
    lineHeight: 18,
  },
  invoiceAttachmentRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  invoiceAttachmentText: {
    fontSize: 12,
    color: Colors.blue0,
  },
  invoiceEmptyState: {
    paddingVertical: 40,
    alignItems: 'center',
  },
  invoiceEmptyText: {
    fontSize: 13,
    color: Colors.grey1,
  },
  // Order cards
  orderCard: {
    width: '100%',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    overflow: 'hidden',
    marginBottom: 12,
  },
  orderCardAccent: {
    height: 4,
    width: '100%',
    backgroundColor: Colors.blue0,
  },
  orderCardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  orderCardNumber: {
    fontSize: 13,
    color: Colors.blue1,
    flex: 1,
    marginRight: 8,
  },
  orderCardDivider: {
    height: 1,
    backgroundColor: Colors.grey0,
  },
  orderCardFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  orderCardDate: {
    fontSize: 12,
    color: Colors.grey13,
  },
  orderCardAmount: {
    fontSize: 13,
    color: Colors.blue0,
  },
  orderEmptyState: {
    paddingVertical: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderStyle: 'dashed',
  },
  orderEmptyText: {
    fontSize: 13,
    color: Colors.grey1,
  },
});

export default React.memo(TodoListVisit, (prev, next) => prev == next);
